import { render, staticRenderFns } from "./UserFinalizeCart.vue?vue&type=template&id=62922318&scoped=true"
import script from "./UserFinalizeCart.vue?vue&type=script&lang=js"
export * from "./UserFinalizeCart.vue?vue&type=script&lang=js"
import style0 from "./UserFinalizeCart.vue?vue&type=style&index=0&id=62922318&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62922318",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62922318')) {
      api.createRecord('62922318', component.options)
    } else {
      api.reload('62922318', component.options)
    }
    module.hot.accept("./UserFinalizeCart.vue?vue&type=template&id=62922318&scoped=true", function () {
      api.rerender('62922318', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cart/UserFinalizeCart.vue"
export default component.exports